import { render, staticRenderFns } from "./ForeignOrgaActivityCode.vue?vue&type=template&id=bb9efd40&"
import script from "./ForeignOrgaActivityCode.vue?vue&type=script&lang=ts&"
export * from "./ForeignOrgaActivityCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports